'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

require('../../styles/sections/template-product-related.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('template-product-related', {
  onLoad: function onLoad() {
    var container = this.container;
    var products = (0, _jquery2.default)(container).find('[data-featured-products]');
    var limit = (0, _jquery2.default)(products).data('collection-products');
    var limit_medium = (0, _jquery2.default)(products).data('medium-collection-products');

    var settings = (0, _slick2.default)({
      slidesToShow: limit,
      slidesToScroll: limit,
      prevArrow: (0, _jquery2.default)(container).find('[data-slick-prev]'),
      nextArrow: (0, _jquery2.default)(container).find('[data-slick-next]'),
      responsive: [{
        breakpoint: Breakpoints['large'],
        settings: {
          slidesToShow: limit_medium,
          slidesToScroll: limit_medium
        }
      }, {
        breakpoint: Breakpoints['small'],
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }]
    });

    products.slick(settings);

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {}
});